export default __webpack_public_path__ + "files/thumbnail-22332c5fcff5ad6f930a1ebf5e94d6cf.png";